export const CSPUrl =
  'https://abtasty.zendesk.com/hc/en-us/articles/360018899099#h_01EYRKE4KGKCWW55EQZSYCFT74' as const;
export const CONTAINER_ID_PREFIX = 'abtasty-qa-assistant-' as const;
export const CONTAINER_ID = `${CONTAINER_ID_PREFIX}container`;
export const DROP_ZONE_ID = `${CONTAINER_ID_PREFIX}dropZone`;
export const HANDLE_ID = `${CONTAINER_ID_PREFIX}handle`;
export const FRAME_ID = `${CONTAINER_ID_PREFIX}frame`;
export const LOGO_ID = 'ab-round_svg__Logo' as const;
export const SESSION_CONTAINER_HEIGHT = 'QAAssistantHeight' as const;
export const SESSION_COLLAPSED = 'AB_TASTY_COLLAPSED' as const;
export const SESSION_LOGO_POSITION = 'AB_TASTY_QAA_LOGO_POSITION' as const;
export const SESSION_FORCED_VARIATIONS = 'ABTastyForcedVariations' as const;
export const SESSION_FORCED_M2E_CAMPAIGNS = 'ABTastyForcedM2eCampaigns' as const;
export const SESSION_FORCED_CAMPAIGNS = 'ABTastyForcedCampaigns';

export const LOGO_MOVING_CLASS = 'logomoving' as const;

export const CONTAINER_COLLAPSE_ANIMATION_TIMEOUT_S = 0.5 as const;
export const LOGO_APPEAR_ANIMATION_TIMEOUT_S = 1 as const;
export const CONTAINER_COLLAPSED_CLASS = 'qa-assistant-collapse' as const;
export const CONTAINER_EXPANDING_CLASS = 'qa-assistant-expanding' as const;

export const API_OAUTH_CODE_V1 = 'abtasty_qa_assistant_token_v1' as const;
export const MOVEMENT_STICKY_DISTANCE_PX = 16 as const;
